import browser from "webextension-polyfill";
import { youTubeWallDetected, youTubeNavigation, toastShownEvent, errorEvent, ErrorType, } from "../shared/index.js";
import { recordEvent } from "./shared.js";
const adWallSelector = "ytd-enforcement-message-view-model";
const playerErrorSelectors = [".ytp-error", "#player-error-message-container"];
const userAvatarSelector = "button#avatar-btn";
const toastSelector = ".yt-notification-action-renderer a[href*='check_ad_blockers']";
const toastTextSelector = "tp-yt-paper-toast yt-formatted-string#text";
const toastTexts = [
    "Experiencing interruptions?",
    "Kommt es zu Unterbrechungen?",
    "¿El vídeo se interrumpe?",
    "La lecture de votre vidéo se bloque",
    "O vídeo está a ter interrupções?",
    "Возникли неполадки?",
    "Hai riscontrato interruzioni?",
    "Oplever du afbrydelser?",
    "Kesinti mi yaşıyorsunuz?",
    "中断",
    "interru",
];
let wallDetected = false;
let domObserver;
const alreadyLoggedSymbol = Symbol("alreadyLoggedSymbol");
function isElement(candidate) {
    return candidate instanceof Element;
}
async function adWallSelectorFound(hasDismiss) {
    var _a;
    const videoPlayer = document.querySelector("video");
    const currentPlaybackTime = (_a = videoPlayer === null || videoPlayer === void 0 ? void 0 : videoPlayer.currentTime) !== null && _a !== void 0 ? _a : 0;
    const userLoggedIn = !!document.querySelector(userAvatarSelector);
    void browser.runtime.sendMessage({
        type: youTubeWallDetected,
        userLoggedIn,
        currentPlaybackTime,
        hasDismiss,
    });
}
async function handleToastNotification(node) {
    const toastNode = node;
    if (toastNode[alreadyLoggedSymbol]) {
        return;
    }
    toastNode[alreadyLoggedSymbol] = true;
    void recordEvent(toastShownEvent);
}
async function handlePlayerError(node) {
    const errorNode = node;
    if (errorNode[alreadyLoggedSymbol]) {
        return;
    }
    const allErrorElements = document.querySelectorAll(playerErrorSelectors.join(","));
    for (const elem of allErrorElements) {
        const typedElem = elem;
        if (typedElem !== errorNode && typedElem[alreadyLoggedSymbol]) {
            errorNode[alreadyLoggedSymbol] = true;
            return;
        }
    }
    errorNode[alreadyLoggedSymbol] = true;
    void recordEvent(errorEvent, {
        category: ErrorType.PLAYER_ERROR,
        applicationVersion: "",
        error: "",
        error_msg: "",
    });
}
function handleMutations(mutations) {
    for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
            if (!isElement(node)) {
                continue;
            }
            const elements = [
                node,
                ...Array.from(node.querySelectorAll([
                    adWallSelector,
                    toastSelector,
                    toastTextSelector,
                    ...playerErrorSelectors,
                ].join(","))),
            ];
            for (const elem of elements) {
                if (elem.tagName === adWallSelector.toUpperCase() && !wallDetected) {
                    const hasDismiss = !!elem.querySelector("#dismiss-button");
                    void adWallSelectorFound(hasDismiss);
                    wallDetected = true;
                }
                else if (elem.tagName === "A" && elem.matches(toastSelector)) {
                    void handleToastNotification(elem);
                }
                else if (elem.tagName === "YT-FORMATTED-STRING" &&
                    elem.matches(toastTextSelector) &&
                    toastTexts.some((toastText) => { var _a; return (_a = elem.textContent) === null || _a === void 0 ? void 0 : _a.includes(toastText); })) {
                    void handleToastNotification(elem);
                }
                else if (elem.tagName === "DIV" &&
                    elem.matches(playerErrorSelectors.join(","))) {
                    void handlePlayerError(elem);
                }
            }
        }
        const target = mutation.target;
        if (isElement(target) &&
            target.tagName === "YT-FORMATTED-STRING" &&
            target.matches(toastTextSelector) &&
            toastTexts.some((t) => { var _a; return (_a = target.textContent) === null || _a === void 0 ? void 0 : _a.includes(t); })) {
            void handleToastNotification(target);
        }
    }
}
function initializeObserver() {
    domObserver = new MutationObserver(handleMutations);
    domObserver.observe(document, {
        attributes: false,
        childList: true,
        characterData: false,
        subtree: true,
    });
}
function logInitialEvent() {
    const userLoggedIn = !!document.querySelector(userAvatarSelector);
    void browser.runtime.sendMessage({ type: youTubeNavigation, userLoggedIn });
}
function handleLoadEvent() {
    setTimeout(() => {
        logInitialEvent();
    }, 5000);
}
export function start() {
    initializeObserver();
    window.addEventListener("load", handleLoadEvent, { once: true });
}
